/**
 * 字体设置工具
 * 用于根据当前语言设置全局字体
 */

// 字体配置常量
const FONT_CONFIG = {
    OVERSEAS: {
        fontFamily: ['Open Sans', 'Arial', 'Helvetica', 'sans-serif'].join(', '),
        logMessage: '🌍 Overseas version font setting completed',
    },
    DOMESTIC: {
        fontFamily: '',
        logMessage: '🇨🇳 Domestic version font setting completed',
    },
} as const;

// 主题令牌类型
export interface ThemeToken {
    fontFamily?: string;
}

// 字体设置结果类型
export interface FontSettingResult {
    themeToken?: ThemeToken;
}

/**
 * 设置全局字体
 * @param language 当前语言 ('zh' | 'en')
 * @returns FontSettingResult 返回 antd 字体配置
 */
export function setGlobalFont(language: string): FontSettingResult {
    // 参数验证
    if (!language || typeof language !== 'string') {
        console.warn('setGlobalFont: invalid language parameter', language);
        return {};
    }

    const isOverseas = language === 'en';
    const config = isOverseas ? FONT_CONFIG.OVERSEAS : FONT_CONFIG.DOMESTIC;

    try {
        // 设置全局字体
        if (typeof document !== 'undefined' && document.body) {
            document.body.style.fontFamily = config.fontFamily;
        }

        // 记录日志
        console.log(config.logMessage);

        // 返回 Ant Design 主题配置
        if (isOverseas) {
            return {
                themeToken: {
                    fontFamily: config.fontFamily,
                },
            };
        }

        return {};
    } catch (error) {
        console.error('font setting failed:', error);
        return {};
    }
}
